import "./pageLoading.scss";
import { quantum } from "ldrs";

quantum.register();

const PageLoading = () => {
  return (
    <div className="pageLoading">
      <l-quantum size="100" speed="1.75" color="black"></l-quantum>
    </div>
  )
}

export default PageLoading